/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { LoggedInHeader } from 'src/appShell/globalHeader/loggedInHeader/LoggedInHeader';
import { LoggedOutHeader } from 'src/appShell/globalHeader/LoggedOutHeader';
import { SkipToMainContentLink } from 'src/appShell/globalHeader/SkipToMainContentLink';
import { useGlobalState } from 'src/core/hooks/useGlobalState';
import { AnnouncementBanners } from 'src/verticals/AnnouncementBanners';

/**
 * Global header that composes both the logged in and logged out headers; decides which
 * one to display based on the auth context.
 */
export const GlobalHeader = observer(() => {
    const { uiStore, rootStore } = useGlobalState();
    const isLanguageStudio = uiStore.portal.kind === 'languageStudio';

    return rootStore.authStore.isSignedIn || isLanguageStudio ? (
        <>
            <SkipToMainContentLink isDarkTheme />
            <LoggedInHeader />
            <AnnouncementBanners />
        </>
    ) : (
        <>
            <SkipToMainContentLink />
            <LoggedOutHeader />
        </>
    );
});
